<template>
  <ModalStructure
    class="usersModal"
    :shouldCloseOnBlur="true"
    :showCloseButton="true"
    :showModal="true"
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingMedium>
        {{ headerText }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <PasswordManagerUsersItemList
        class="passwordManagerUsersItemList"
        :defaultFilters="defaultFilters"
        :defaultSortBy="defaultSortBy"
        :excludedColumns="excludedColumns"
        :selectable="selectableItemList"
        :showEnrollButton="false"
        :showRefreshButton="false"
        :showResendInvitationButton="showResendInvitationButton"
      />
    </template>
  </ModalStructure>
</template>
<script>

import {
  HeadingMedium,
  ModalStructure,
} from '@jumpcloud/ui-components';

import PasswordManagerUsersItemList from 'client/PasswordManager/Users/PasswordManagerUsersItemList.vue';

export default {
  name: 'PasswordManagerUsersItemListModal',

  components: {
    HeadingMedium,
    ModalStructure,
    PasswordManagerUsersItemList,
  },

  props: {
    defaultFilters: {
      type: Array,
      required: false,
      default: () => [],
    },

    defaultSortBy: {
      type: String,
      default: 'name',
    },

    excludedColumns: {
      type: Array,
      default: () => [],
    },

    headerText: {
      type: String,
      required: true,
    },

    selectableItemList: Boolean,

    showResendInvitationButton: Boolean,
  },

  methods: {
    handleClose() {
      this.$emit('closeUsersModal');
    },
  },
};
</script>

<style scoped>
.passwordManagerUsersItemList {
  height: calc(100vh - 20rem);
  margin-top: var(--jc-spacer);
}

.usersModal {
  --modal-width: 1000px;
}
</style>
